import { REACT_QUERY_KEYS } from 'common'
import { setPurposesUS } from 'common/services/us/us-purposes'
import { PatchPurposeRequest } from 'common/types'
import { useNavigate } from 'react-router-dom'
import { Routes } from 'common/constants'
import { useAppContext } from 'contexts/app-context/hooks'
import { entityPayloadMap } from 'contexts/app-context/types/app-context/components/utils'

import { useMutation, useQueryClient } from '@tanstack/react-query'

type UseSetGoalsProps = {
  showSuccessToggle: () => void
}

export const useSetPurposesUS = ({ showSuccessToggle }: UseSetGoalsProps) => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { userCountry, userAccountType, userSelectedEntity, isUSBranch } = useAppContext()

  const mutation = useMutation({
    mutationFn: ({ body, purpose }: PatchPurposeRequest) => {
      const customHeaders = userCountry &&
        userSelectedEntity && {
          'x-inter-user-org': userCountry,
          'x-inter-account-org': entityPayloadMap[userSelectedEntity],
        }

      if (
        userAccountType !== undefined &&
        userCountry !== undefined &&
        userSelectedEntity !== undefined
      )
        return setPurposesUS({
          body,
          userAccountType,
          userCountry,
          userSelectedEntity,
          productId: purpose,
          isUSBranch,
          headers: customHeaders,
        })

      throw new Error('Error ao recuperar as informações do usuário.')
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [REACT_QUERY_KEYS.US_PURPOSES],
      })

      const {
        promotionsAndNewsletterCommunicationChannel: { enabled },
      } = variables.body

      if (enabled) showSuccessToggle()
    },
    onError: () => navigate(Routes.ERROR),
  })

  return {
    ...mutation,
  }
}
